import { FormField } from '@/sanity.types';
import { z } from 'zod';

export interface FieldConfig {
  _key: string;
  inputType:
    | 'text'
    | 'email'
    | 'password'
    | 'number'
    | 'textarea'
    | 'select'
    | 'checkbox'
    | 'radio'
    | 'date';
  fieldName: string;
  fieldLabel: string;
  placeholder?: string;
  required: boolean;
  checkboxOptions?: { label: string; value: string }[]; // For checkbox
  options?: { label: string; value: string }[]; // For select, checkbox, radio
  validation?: {
    min?: number;
    max?: number;
    pattern?: string;
    message?: string;
  };
}

export interface FormConfig {
  id?: string;
  title?: string;
  // fields: FieldConfig[] | undefined;
  fields:
    | ({
        _key: string;
      } & FormField)[]
    | undefined;
  submitEndpoint: string;
}

export const generateZodSchema = (formConfig: FormConfig) => {
  // eslint-disable-next-line
  const schemaMap: Record<string, any> = {};

  formConfig.fields?.forEach((field) => {
    // eslint-disable-next-line
    let schema: any = z.string();

    // Set up base schema based on field type
    switch (field.inputType) {
      case 'email':
        schema = z.string().email({ message: 'Invalid email address' });
        break;
      case 'checkbox':
        if (
          field.checkboxOptions?.length &&
          field.checkboxOptions?.length > 1
        ) {
          schema = z.array(z.string()).min(1, 'Select at least one option');
        } else {
          schema = z.boolean();
        }
        break;
      default:
        schema = z.string();
    }

    // Apply common validations
    if (field.inputType !== 'checkbox') {
      if (field.required) {
        schema = schema.min(1, { message: `${field.fieldLabel} is required` });
      } else {
        schema = schema.optional();
      }
    }

    schemaMap[field.fieldName] = schema;
  });

  return z.object(schemaMap);
};
